const { StageClearContainer } = require('./container/stageClearContainer');
const { GamePauseContainer } = require('./container/gamePauseContainer');
const { GameOverContainer } = require('./container/gameOverContainer');
const { GameClearContainer } = require('./container/gameClearContainer');
const { StageStartContainer } = require('./container/stageStartContainer');
const { StageScenarioContainer } = require('./container/stageScenarioContainer');
const { ResultContainer } = require('./container/resultContainer');

export default { StageClearContainer, GamePauseContainer, GameOverContainer, GameClearContainer, StageStartContainer, StageScenarioContainer, ResultContainer };